import { Link } from "react-router-dom";
import { Logo } from "./Logo";
import { Footer } from "./Footer";

// Lekki, publiczny layout (bez konta) dla ścieżki wejścia: Asystent i podgląd kreatora.
export const PublicShell = ({ children }) => {
  return (
    <div className="grain min-h-screen bg-brand-bg text-brand-text">
      <header data-testid="public-header" className="sticky top-0 z-40 border-b border-brand-line bg-brand-bg/90 backdrop-blur">
        <div className="mx-auto flex h-16 max-w-content items-center justify-between px-4 md:px-8">
          <Link to="/" aria-label="Promptivo — strona główna" className="shrink-0">
            <Logo height={30} />
          </Link>
          <div className="flex items-center gap-3">
            <Link
              to="/logowanie"
              data-testid="public-login-link"
              className="text-sm font-medium text-brand-sec transition-colors hover:text-brand-text"
            >
              Zaloguj się
            </Link>
            <Link
              to="/rejestracja"
              data-testid="public-register-link"
              className="rounded-button bg-brand-accent px-4 py-2 text-sm font-semibold text-brand-on transition-transform hover:-translate-y-0.5"
            >
              Załóż bezpłatne konto
            </Link>
          </div>
        </div>
      </header>
      <main className="mx-auto max-w-content px-4 py-10 md:px-8 md:py-14">{children}</main>
      <Footer />
    </div>
  );
};
